import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Upload Your Photo',
  desc: 'Add a selfie or any photo to create your custom character base.',
  color: 'bg-[#FFD700]'
}, {
  num: '2',
  title: 'Choose Your Style',
  desc: 'Pick from Comic, Manga, Manhwa or Cartoon aesthetics.',
  color: 'bg-[#ff4d4d]'
}, {
  num: '3',
  title: 'Generate Your Story',
  desc: 'Write a prompt and get a full comic generated in minutes.',
  color: 'bg-[#1a5cff]'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-24 bg-[#f4f4f4] relative" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <div className="text-center mb-20" data-id="element-77">
          <motion.div initial={{
          opacity: 0,
          scale: 0.5
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-block relative" data-id="element-78">
            {/* Speech bubble background */}
            <div className="absolute inset-0 bg-white comic-border comic-shadow rounded-[3rem] -z-10 scale-110" data-id="element-79"></div>
            <div className="absolute -bottom-6 left-1/2 w-8 h-8 bg-white border-r-4 border-b-4 border-black -rotate-45 -translate-x-1/2 -z-20" data-id="element-80"></div>

            <h2 className="font-bangers text-5xl md:text-6xl text-black px-8 py-4" data-id="element-81">
              How It Works
            </h2>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-82">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-2 bg-black border-y-2 border-dashed border-white z-0" data-id="element-83"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-84">
              <div className={`w-24 h-24 ${step.color} rounded-full comic-border comic-shadow flex items-center justify-center mb-8 relative`} data-id="element-85">
                <span className="font-bangers text-5xl text-white text-stroke-black" data-id="element-86">
                  {step.num}
                </span>
                {/* Decorative burst */}
                <div className="absolute -inset-2 border-4 border-black border-dashed rounded-full animate-[spin_10s_linear_infinite] opacity-50" data-id="element-87"></div>
              </div>

              <div className="bg-white p-6 comic-border comic-shadow-sm w-full relative" data-id="element-88">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 w-6 h-6 bg-white border-t-4 border-l-4 border-black rotate-45" data-id="element-89"></div>
                <h3 className="font-bangers text-3xl mb-3" data-id="element-90">{step.title}</h3>
                <p className="font-inter font-medium text-gray-700" data-id="element-91">
                  {step.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}